module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-louis.1311ea59.svg";